<template>
  <div>
    <b-modal
      id="modal-role"
      ref="my-modal"
      cancel-variant="outline-secondary"
      ok-title="Save"
      cancel-title="Close"
      centered
      :title="$t('DEBTIA_API_TOKEN_DETAILS')"
      size="lg"
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="modalLoads === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-form>
          <validation-observer
            ref="apiTokenForm"
            tag="form"
          >
            <b-row>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_REASON')"
                  label-for="reason"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Reason"
                    rules="required"
                  >
                    <v-select
                      v-model="details.reason"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="reasonOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="reason"
                      :value="'person'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_DESCRIPTION')"
                  label-for="description"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="description"
                  >
                    <b-form-textarea
                      id="textarea-rows"
                      v-model="details.description"
                      :placeholder="$t('DEBTIA_DESCRIPTION')"
                      rows="8"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BForm, BOverlay, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
import constants from '@/app-configs/constants'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BOverlay,
    BFormTextarea,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    orderData: {
      type: Object,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      snowOption: {
        theme: 'snow',
      },
      required,
      details: {},
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
    }
  },
  watch: {
    orderData: {
      handler() {
        this.details = { ...this.orderData }
        console.log('this.details', this.details)
      },
    },
    modalLoads: {
      handler() {
        console.log('this.modalLoads', this.modalLoads)
      },
    },
  },
  setup() {
    const reasonOptions = [
      { label: 'Betaling: Forventeda uduskudt betalingsdato', value: 'Betaling: Forventeda uduskudt betalingsdato' },
      { label: 'Betaling: Forventeda anden pris', value: 'Betaling: Forventeda anden pris' },
      { label: 'Betaling: Forventeda arlig betaling', value: 'Betaling: Forventeda arlig betaling' },
      { label: 'Betaling: Klient eksisterer i forvejen', value: 'Betaling: Klient eksisterer i forvejen' },
      { label: 'Betaling: Blev lovet mere end vi kan levere', value: 'Betaling: Blev lovet mere end vi kan levere' },
    ]

    return {
      reasonOptions,
    }
  },
  methods: {
    submitHandler(evt) {
      evt.preventDefault()
      this.$refs.apiTokenForm.validate().then(success => {
        if (success) {
          this.modalLoads = true
          const data = { ...this.orderData, ...this.details }
          const url = `${constants.baseUrl}/clients/delete-order`
          axios.post(url, { ...data }).then(response => {
            if (response.status === 200) {
              this.$nextTick(() => {
                this.$refs['my-modal'].toggle('#toggle-btn')
              })
              // this.details = {
              //   id: 0, apiToken: '', name: '', description: '', parent_id: JSON.parse(localStorage.getItem('userData')).data.id,
              // }
              this.modalLoads = false
              this.$router.replace('/orders')
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Client Updated',
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: 'Order Successfully Delted!',
                    },
                  })
                })
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">

</style>
